import { useMutation } from 'react-query';

import api from '@root/api';

export default function useCreateSelfServeEnterprisePipeline() {
  return useMutation(
    (data) => api.billing.createSelfServeEnterprisePipeline(data),
  );
}
